import { render } from "./Koffietafel.vue?vue&type=template&id=a17da140"
import script from "./Koffietafel.vue?vue&type=script&lang=js"
export * from "./Koffietafel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__